import React from "react";
import NotificationsOpenClosedChart from "../child/NotificationsOpenClosedChart";
import NotificationsOutstandingChart from "../child/NotificationsOutstandingChart";
import NotificationsPriorityChart from "../child/NotificationsPriorityChart";

const WorkRequestsDashboardLayer = () => {
  return (
    <div className='row gy-4 p-24'>
      <NotificationsOpenClosedChart />
      <NotificationsOutstandingChart />
      <NotificationsPriorityChart />
    </div>
  );
};

export default WorkRequestsDashboardLayer;
